var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-header"},[_c('EBreadcrumb'),_vm._t("header-btn")],2),(_vm.$slots.customCon)?_vm._t("customCon"):_c('div',{staticClass:"main-content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }